module.exports = "https://bin.bnbstatic.com/_next/static/images/step3-f9040340bc2f3b82c3f27d6c57359758.png";